import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { KeyFill } from 'react-bootstrap-icons';

import { UserSecurityDetailsProps } from './security.types';
import api from '../../services/api';

const SecurityDetails: React.FC<UserSecurityDetailsProps> = (props: UserSecurityDetailsProps) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState<number | null>();
  const [isDisabled, setIsDisabled] = useState(true);
  const [fieldsToUpdate, setFieldsToUpdate] = useState<{ [key: string]: string }>({
    currentPassword: '',
    password: '',
    password2: '',
  });

  useEffect(() => {
    const { userId, profile } = props.userProfile;
    if (userId) {
      setUserId(userId);
    }
  }, [props]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const requestBody = {
      currentPassword: fieldsToUpdate.currentPassword,
      newPassword: fieldsToUpdate.password,
    };
    try {
      await api.put(`/users/${userId}/password`, requestBody);
      alert('Contraseña actualizada correctamente');
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || 'Ocurrió un error inesperado. Intenta nuevamente.';

      alert(errorMessage);
    }
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFieldsToUpdate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    setIsDisabled(
      !fieldsToUpdate.password ||
        !fieldsToUpdate.password2 ||
        fieldsToUpdate.password !== fieldsToUpdate.password2,
    );
  }, [fieldsToUpdate]);

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Row className="mt-3 sticky-header">
          <Col md={10}>
            <Button variant="secondary" onClick={() => navigate('/dashboard')}>
              Regresar
            </Button>
          </Col>
          <Col md={2}>
            <Button variant="primary" onClick={handleSubmit} disabled={isDisabled}>
              Guardar
            </Button>
          </Col>
        </Row>
        <Row className="mt-4 form-title">
          <Col md={6} className="d-flex align-items-center">
            <KeyFill size={18} className="me-2" />
            <h4>Contraseña</h4>
          </Col>
        </Row>
        <Form.Group as={Row} className="mt-4">
          <Col md={12}>
            <Form.Label className="fw-bold">Contraseña Actual</Form.Label>
            <Form.Control
              type="password"
              name="currentPassword"
              value={fieldsToUpdate.currentPassword}
              onChange={handleOnChange}
            />
          </Col>
          <Col md={12}>
            <Form.Label className="fw-bold">* Nueva contraseña</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={fieldsToUpdate.password}
              onChange={handleOnChange}
            />
          </Col>
          <Col md={12}>
            <Form.Label className="fw-bold">* Repetir contraseña</Form.Label>
            <Form.Control
              type="password"
              name="password2"
              value={fieldsToUpdate.password2}
              onChange={handleOnChange}
            />
          </Col>
        </Form.Group>
      </Form>
    </Container>
  );
};

export default SecurityDetails;
